<div class="error404">
  <div class="errorContainer">
    <h1>Oops!</h1>
    <p>Looks like something went wrong</p>
    <p>You can return to our
      <a routerLink="/safety-recommendations">home page</a>
      or
      <a routerLink="/safety-recommendations">contact us</a>
    </p>
  </div>
</div>
